export const PATH = '/user';

export const addBaseRoute = (route) => `${PATH}${route}`;
